import React from 'react';
import { useSelector } from 'react-redux';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getLastViewedProduct } from '@/selectors/lastViewedProductSelectors';
import LFLink from './LFLink';
import { IconCity } from '../icons';

const AirportLinkWithImage = ({ background, airport, ...restofProps }) => {
  const lastViewedProduct = useSelector(getLastViewedProduct);
  const cmsImgBaseUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);

  const { iata, image, name, city } = airport;
  const { position } = restofProps;
  const urlAirportIata = iata ? `/${iata}` : '';

  return (
    <LFLink
      key={`featured-airports-link-${iata}`}
      element={`header>>Find a City or Airport>>Popular Airports>>position ${position}>>${iata}`}
      className="tw-inline-flex tw-min-w-0 tw-max-w-80"
      to={`${lastViewedProduct}${urlAirportIata}/`}
      onClickHandler={restofProps?.onClickHandler}
    >
      {image ? (
        <img
          alt=""
          src={`${cmsImgBaseUrl}${image}`}
          className="tw-h-12 tw-w-12 tw-rounded-lg tw-bg-gray-300"
        />
      ) : (
        <IconCity />
      )}
      <div className="tw-ml-4 tw-flex tw-min-w-0 tw-flex-col">
        <span
          className={
            background === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'
          }
        >
          {name}
        </span>
        <span
          className={
            background === 'dark'
              ? 'tw-text-gray-300'
              : 'tw-text-xs tw-text-gray-700'
          }
        >
          {iata} • {airport.location ? airport.location.city : city}
        </span>
      </div>
    </LFLink>
  );
};

export default AirportLinkWithImage;
